import request from '@/utils/request'

let ServiceApi = {
    /*列表*/
    servicelist(data, errorback) {
        return request._post('/shop/service.service/index', data, errorback);
    },
    /*添加*/
    add(data, errorback) {
        return request._post('/shop/service.service/add', data, errorback);
    },
    /*修改*/
    edit(data, errorback) {
        return request._post('/shop/service.service/edit', data, errorback);
    },
    /*修改获取数据*/
    getEdit(data, errorback) {
        return request._get('/shop/service.service/edit', data, errorback);
    },
    /*删除*/
    del(data, errorback) {
        return request._post('/shop/service.service/del', data, errorback);
    },

    /**
     * 订单列表
     */
    orderlist(data, errorback) {
        return request._post('/shop/service.order/index', data, errorback);
    },
    
    /**
     * 订单取消
     */
    orderCancel(data, errorback) {
        return request._post('/shop/service.order/orderCancel', data, errorback);
    },

    /**
     * 获取设置数据
     */
     getSetting(data, errorback) {
        return request._get('/shop/service.service/setting', data, errorback);
    },
    /**
     * 编辑设置数据
     */
     editSetting(data, errorback) {
        return request._post('/shop/service.service/setting', data, errorback);
    },
    /**
     * 编辑设置数据
     */
     recordList(data, errorback) {
        return request._post('/shop/service.record/index', data, errorback);
    },

    
}

export default ServiceApi;



// WEBPACK FOOTER //
// ./src/api/service.js